export default __webpack_public_path__ + "static/media/warning.929f4c7d.svg";